import { zeroAddress, type Address } from "viem";
import { env, missingRequiredContracts } from "../config/env";

export const contractAddresses = {
  holderLpVault: env.holderLpVaultAddress,
  lpTimeVault: env.lpTimeVaultAddress,
  buybackBurnVault: env.buybackBurnVaultAddress,
  splitVault: env.splitVaultAddress,
  tokenOverride: env.tokenAddressOverride,
  lpPairOverride: env.lpPairAddressOverride,
  referralRouter: env.referralRouterAddress,
};

export const missingContracts = missingRequiredContracts();
export const hasRequiredContracts = missingContracts.length === 0;

export function isBoundAddress(address: Address | undefined): address is Address {
  return Boolean(address && address !== zeroAddress);
}

export function resolveTokenAddress(boundToken?: Address): Address | undefined {
  return contractAddresses.tokenOverride ?? (isBoundAddress(boundToken) ? boundToken : undefined);
}

export function resolveLpAddress(holderLpToken?: Address, lpTimeToken?: Address): Address | undefined {
  return (
    contractAddresses.lpPairOverride ??
    (isBoundAddress(holderLpToken) ? holderLpToken : undefined) ??
    (isBoundAddress(lpTimeToken) ? lpTimeToken : undefined)
  );
}
